<form [formGroup]="form" autocomplete="off">

    <p-dialog showHeader="false" [(visible)]="display" [modal]="true" width="900" [baseZIndex]="10001"
              header="Buscador de Puntos de Operadores TRACES" (onShow)="showDialogMaximized(dialDetail)" #dialDetail>

        <div class="animated fadeIn">

            <div class="row">
                <div class="col-md-12">

                    <div class="card card-accent-success animated fadeIn">

                        <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Filtros
                                <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">


                            <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">
                                <div class="row">

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label required-field" for="intPais">País Unión Europea</label>
                                        <ng-select [items]="listPais"
                                                   bindLabel="Descripcion"
                                                   bindValue="ConvenioIsoTraces"
                                                   formControlName="IdPais"
                                                   loadingText="Cargando..."
                                                   [loading]="!(listPais)"
                                                   [ngClass]="displayFieldCssNgSelect('IdPais')"
                                                   notFoundText="País no encontrado"
                                                   placeholder="-- Seleccione un País --"
                                                   clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                            </ng-template>
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','required')">
                                            País es obligatorio
                                        </div>

                                    </div>


                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="inpDescripcion">Nombre</label>
                                        <input formControlName="Nombre" name="Nombre" class="form-control" maxlength="100"
                                               inputStyleClass="form-control" type="text" value="">
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="inpDescripcion">Tipo Operador</label>                                        
                                        <ng-select loadingText="Cargando..."
                                                   [items]="listTipoOperador"
                                                   bindLabel="Descripcion"
                                                   bindValue="Descripcion"
                                                   formControlName="TipoOperador"
                                                   [readonly]="!listTipoOperador || listTipoOperador.length === 0"
                                                   [loading]="!listTipoOperador || listTipoOperador.length === 0"
                                                   notFoundText="Tipo Operador no encontrado"
                                                   placeholder="-- Seleccione un Tipo Operador --"
                                                   [(ngModel)]="selectedValue"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>
                                    </div>

                                </div>



                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group-0 float-right">

                                            <div class="btn-group">
                                                <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                            </div>

                                            <div class="btn-group">
                                                <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>




            </div>

            <!--GRID DATOS-->
            <div *ngIf="searchingButton" class="row">
                <div class="col-md-12">
                    <div class="label-msg-info m-1">
                        <i class="fa fa-info-circle fa-lg"></i> Haga doble click para seleccionar un Operador
                    </div>
                    <div class="card card-accent-success">
                        <div class="card-header-buscador">
                            <i class="fa fa-align-justify"></i> Listado de Operadores EURPO
                        </div>

                        <div class="card-body">

                            <p-table #tableSearch autoLayout="true" [value]="resultOperadores.ResultList" [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                     selectionMode="single" [(selection)]="selectedTImportador" dataKey="RefTraces"
                                     [columns]="cols"  [rows]="resultOperadores?.PageSize" [totalRecords]="resultOperadores.TotalCount" [loading]="loading"
                                     styleClass="table table-responsive-sm  table-sm">

                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">

                                    <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" (click)="onSelect(rowData)" (dblclick)="onRowDblClick($event, rowData)">
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span>
                                                {{rowData[col.field]}}
                                            </span>

                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>

                            <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <p-footer>
            <button pButton (click)="acceptDialog()" [disabled]="noAccepted()" label="Aceptar" class="p-confirm-dialog-accept" icon="pi pi-check" title="Aceptar"></button>
            <button pButton (click)="cancelDialog()" label="Cancelar" class="p-confirm-dialog-reject" icon="pi pi-times" title="Cancelar"></button>
        </p-footer>


    </p-dialog>

</form>

